<div id="buttons">
  <div class="buttons d-flex justify-content-around align-items-center">
    <ng-container [ngSwitch]='true'>
      <button *ngSwitchCase='!!text' class="button" id="single" type="button" mdbBtn mdbWavesEffect (click)="btnClick()">{{ text }}</button>
      <ng-container *ngSwitchCase='!!backText && !!forwardText'>
        <button class="button" id="back" type="button" mdbBtn mdbWavesEffect (click)="btnClickBack()">{{ backText }}</button>
        <button class="button" id="forward" type="button" mdbBtn mdbWavesEffect (click)="btnClickForward()">{{ forwardText }}</button>
      </ng-container>
      <ng-container *ngSwitchCase='!!buttons'>
        <div class="multiple d-flex flex-column align-items-center align-self-start" *ngFor='let button of buttons; last as isLast' [ngClass]="{'special': button.special, 'borders': !isLast}" (click)='buttonsEvent.emit(button.event)'>
          <button class="button" type="button" mdbBtn mdbWavesEffect><fa-icon [icon]="button.icon"></fa-icon></button>
          <p>{{ button.text }}</p>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>